// extracted by mini-css-extract-plugin
module.exports = {"root":"FirstBookingPromoDialog_root__a7xMO","promoBanner":"FirstBookingPromoDialog_promoBanner__oTFpE","container":"FirstBookingPromoDialog_container__H3wl5"};